"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callScriptNames = void 0;
var callScriptNames;
(function (callScriptNames) {
    callScriptNames["CONSENT_CALL_FIRST_US"] = "consent-call-first-us";
    callScriptNames["CONSENT_KIT_FIRST_UNITED"] = "consent-kit-first-united";
    callScriptNames["CONSENT_KIT_FIRST_US"] = "consent-kit-first-us";
    callScriptNames["CONSENT_UK"] = "consent-uk";
    callScriptNames["FAX_CONFIRMATION_US"] = "fax-confirmation-us";
    callScriptNames["ONLINE_KIT_REQUEST_US"] = "online-kit-request-us";
    callScriptNames["PCP_CONFIRMATION_US"] = "pcp-confirmation-us";
    callScriptNames["REMINDER_UK"] = "reminder-uk";
    callScriptNames["REMINDER_US"] = "reminder-us";
    callScriptNames["SUPPORT_UK"] = "support-uk";
    callScriptNames["SUPPORT_US"] = "support-us";
    callScriptNames["TEST_FAILED_US"] = "test-failed-us";
    callScriptNames["TEST_FAILED_UK"] = "test-failed-uk";
    callScriptNames["CONSENT_KIT_FIRST_US_OPTUM_UC1"] = "consent-kit-first-us-optum-uc1";
    callScriptNames["CONSENT_KIT_FIRST_US_OPTUM_UC2"] = "consent-kit-first-us-optum-uc2";
    callScriptNames["CONSENT_CALL_FIRST_US_OPTUM"] = "consent-call-first-us-optum";
    callScriptNames["PCP_CONFIRMATION_US_OPTUM"] = "pcp-confirmation-us-optum";
    callScriptNames["REMINDER_US_OPTUM_UC1"] = "reminder-us-optum-uc1";
    callScriptNames["REMINDER_US_OPTUM_UC2"] = "reminder-us-optum-uc2";
    callScriptNames["SUPPORT_US_OPTUM"] = "support-us-optum";
    callScriptNames["TEST_FAILED_US_OPTUM"] = "test-failed-us-optum";
    callScriptNames["POST_TEST_US_OPTUM_UC1"] = "post-test-us-optum-uc1";
    callScriptNames["POST_TEST_US_OPTUM_UC2"] = "post-test-us-optum-uc2";
    callScriptNames["POST_TEST_US"] = "post-test-us";
    callScriptNames["POST_TEST_US_GEISINGER"] = "post-test-us-geisinger";
})(callScriptNames || (exports.callScriptNames = callScriptNames = {}));
